export default __webpack_public_path__ + "static/media/banner-topo-sobre.f65426cf.png";